// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25369
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25369 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
export const PageId = Object.freeze({
  OrderCenter_CancelSubmit: 'OrderCenter_CancelSubmit'
})

interface IPVTrackParamsRecord {
  /** 订单取消申请成功页 */
OrderCenter_CancelSubmit: undefined
}

const sendPv = {
  /** PV-订单取消申请成功页 */
OrderCenter_CancelSubmit: () => {
    eventTrackingUtils.submitPV({page_id:PageId.OrderCenter_CancelSubmit});
  },
}

interface IExpoTrackParamsRecord {
  /** 订单详情按钮曝光 */
OrderCancelSubmit_OrderDetailExpo: {
/** 订单id  */
orderId: string}
  /** 继续购物按钮曝光 */
OrderCancelSubmit_ContinueShoppingExpo: {
/** 订单id  */
orderId: string}
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 订单详情按钮曝光 */
  OrderCancelSubmit_OrderDetailExpo:'OrderCancelSubmit_OrderDetailExpo',
/** 继续购物按钮曝光 */
  OrderCancelSubmit_ContinueShoppingExpo:'OrderCancelSubmit_ContinueShoppingExpo',
})

interface IClickTrackParamsRecord {
  /** 订单详情按钮 */
OrderCancelSubmit_OrderDetail: {
/** 订单id  */
orderId: string}
  /** 继续购物按钮 */
OrderCancelSubmit_ContinueShopping: {
/** 订单id  */
orderId: string}
}

const sendClickTrack = {
  /** 点击事件上报-订单详情按钮 */
OrderCancelSubmit_OrderDetail: (json_param: IClickTrackParamsRecord['OrderCancelSubmit_OrderDetail']) => {
    eventTrackingUtils.submitCL({event_id:'OrderCancelSubmit_OrderDetail',json_param});
  },
  /** 点击事件上报-继续购物按钮 */
OrderCancelSubmit_ContinueShopping: (json_param: IClickTrackParamsRecord['OrderCancelSubmit_ContinueShopping']) => {
    eventTrackingUtils.submitCL({event_id:'OrderCancelSubmit_ContinueShopping',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}